import { UiCustomerProfile } from '../../types';
import {
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemButtonProps,
  ListItemProps,
  ListItemText,
  Skeleton,
} from '@mui/material';
import { AvatarCustomer } from '../Avatar/AvatarCustomer';

export type CustomerListItemContentProps = {
  loading?: boolean;
  customer?: UiCustomerProfile | null;
};

function CustomerListItemContent({ loading, customer }: CustomerListItemContentProps) {
  return (
    <>
      <ListItemAvatar>
        <AvatarCustomer customer={customer} />
      </ListItemAvatar>
      <ListItemText
        primary={loading ? <Skeleton /> : customer?.name}
        secondary={
          loading ? <Skeleton /> : customer?.username ? `@${customer.username}` : undefined
        }
      />
    </>
  );
}

export type CustomerListItemProps = ListItemProps<'li', CustomerListItemContentProps>;

export function CustomerListItem({ loading, customer, ...props }: CustomerListItemProps) {
  return (
    <ListItem {...props}>
      <CustomerListItemContent loading={loading} customer={customer} />
    </ListItem>
  );
}

export type CustomerListItemButtonProps = ListItemButtonProps<'div', CustomerListItemContentProps>;

export function CustomerListItemButton({
  loading,
  customer,
  ...props
}: CustomerListItemButtonProps) {
  return (
    <ListItem disablePadding>
      <ListItemButton {...props}>
        <CustomerListItemContent loading={loading} customer={customer} />
      </ListItemButton>
    </ListItem>
  );
}
